import React, {useEffect} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexDirection, mb, mh, ml, mt, onDesktop, p, pr} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Input} from "@pg-design/inputs-module";
import {Highlight, Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {CreditOffersFiltersBaseData} from "../../constants/CreditOffersFiltersBaseData";
import {useFiltersState} from "../../hooks/use_filters_state";
import {creditCalculatorAnalytics, CreditCalculatorGTMEvent, CreditCalculatorListingActions} from "../../tracking/credit_gtm";
import {ICreditOffersFilters} from "../../types/ICreditOffersFilters";
import {setCreditFiltersStorage} from "../../utils/credit_storage";
import {formatBigNumbers} from "../../utils/format_big_numbers";
import {CreditOfferFilterInputs} from "./CreditOfferFilterInputs";

const calculatorSvg = require("../../images/calculator.svg");

interface IProps {
    onFiltersSet: (selectedFilters: ICreditOffersFilters, initialSet?: boolean) => void;
}

export const CreditOffersFilters = (props: IProps) => {
    const {onFiltersSet} = props;

    const {price, period, contribution, areDefaultValuesSet, updateValue} = useFiltersState(CreditOffersFiltersBaseData);
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    useEffect(() => {
        areDefaultValuesSet &&
            onFiltersSet(
                {
                    price,
                    period,
                    contribution,
                    credit_amount: Math.round(price - contribution)
                },
                true
            );
    }, [areDefaultValuesSet]);

    const onClick = () => {
        const selectedFilters: ICreditOffersFilters = {
            price,
            period,
            contribution,
            credit_amount: price - contribution
        };
        creditCalculatorAnalytics.gtm.creditCalculatorEvent(CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR, {
            credit_action: CreditCalculatorListingActions.FILTERS_ACCEPT,
            ...selectedFilters
        });
        setCreditFiltersStorage(selectedFilters);
        onFiltersSet(selectedFilters);
    };

    return (
        <div>
            <div css={headerWrapper}>
                <Image src={calculatorSvg} alt="Kalkulator" width="130" height="110" />
                <div>
                    <Text
                        variant="headline_1"
                        align={isMobile ? "center" : "start"}
                        css={[onDesktop(ml(3))]}
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.TITLE}
                    >
                        Kalkulator kredytu hipotecznego: <Highlight>sprawdź najlepsze oferty</Highlight>
                    </Text>
                    <Text
                        variant="body_copy_1"
                        align={isMobile ? "center" : "start"}
                        css={[mt(1), onDesktop(ml(3))]}
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.SUBTITLE}
                    >
                        Kalkulator kredytu hipotecznego pomoże Ci nie tylko znaleźć najlepsze oferty banków, ale również oszacować miesięczną ratę oraz
                        zaplanować Twój budżet domowy. Już teraz sprawdź, jakie możliwości daje kalkulator kredytowy w Twoim przypadku!
                    </Text>
                </div>
            </div>

            <div css={filtersWrapper}>
                {CreditOffersFiltersBaseData.map((inputData) => (
                    <div key={inputData.title} css={inputWrapper} id={CREDIT_PAGES_IDS.COMMON.FORM_CONTAINER}>
                        <Text variant="body_copy_2" css={labelStyle}>
                            {inputData.title}
                        </Text>

                        <CreditOfferFilterInputs
                            {...inputData}
                            price={price}
                            period={period}
                            contribution={contribution}
                            updateValue={updateValue}
                            dataTestId={inputData.name}
                        />
                    </div>
                ))}
                <div css={inputWrapper}>
                    <Text variant="body_copy_2" css={labelStyle}>
                        Kwota kredytu
                    </Text>
                    <Input
                        value={formatBigNumbers(price - contribution)}
                        rightElement={
                            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                                zł
                            </Text>
                        }
                        inputtextalign="right"
                        disabled
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.CREDIT_AMOUNT}
                    />
                </div>
                <Button variant="filled_primary" size="small" onClick={onClick} css={btnStyle}>
                    Zastosuj
                </Button>
            </div>
        </div>
    );
};

const headerWrapper = css`
    ${flex("center", "start")};
    ${flexDirection("column")};
    ${mb(2)};

    ${onDesktop(flexDirection("row"))};

    & > div {
        ${flexDirection("column")}
    }
`;

const filtersWrapper = (theme: Theme) => css`
    ${backgroundColor(theme.colors.background[200])};
    ${elevation(4)};
    ${mb(5)};
    ${p(2)};
    margin-left: -${calculateRemSize(1.5)};
    margin-right: -${calculateRemSize(1.5)};

    ${onDesktop(css`
        ${flex("end", "start")};
        ${borderRadius(2)};
        ${mh(0)};
    `)};
`;

const labelStyle = css`
    ${mb(0.5)};
`;

const inputWrapper = css`
    ${mb(2)};

    ${onDesktop(css`
        ${pr(2)};
        ${mb(0)};
        width: 20%;
    `)};
`;

const btnStyle = css`
    width: 100%;

    ${onDesktop(css`
        width: 20%;
    `)};
`;
import React, {useEffect} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, calculateRemSize, flex, flexDirection, mb, mh, ml, mt, onDesktop, p, pr} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Input} from "@pg-design/inputs-module";
import {Highlight, Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {CreditOffersFiltersBaseData} from "../../constants/CreditOffersFiltersBaseData";
import {useFiltersState} from "../../hooks/use_filters_state";
import {creditCalculatorAnalytics, CreditCalculatorGTMEvent, CreditCalculatorListingActions} from "../../tracking/credit_gtm";
import {ICreditOffersFilters} from "../../types/ICreditOffersFilters";
import {setCreditFiltersStorage} from "../../utils/credit_storage";
import {formatBigNumbers} from "../../utils/format_big_numbers";
import {CreditOfferFilterInputs} from "./CreditOfferFilterInputs";

const calculatorSvg = require("../../images/calculator.svg");

interface IProps {
    onFiltersSet: (selectedFilters: ICreditOffersFilters, initialSet?: boolean) => void;
}

export const CreditOffersFilters = (props: IProps) => {
    const {onFiltersSet} = props;

    const {price, period, contribution, areDefaultValuesSet, updateValue} = useFiltersState(CreditOffersFiltersBaseData);
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    useEffect(() => {
        areDefaultValuesSet &&
            onFiltersSet(
                {
                    price,
                    period,
                    contribution,
                    credit_amount: Math.round(price - contribution)
                },
                true
            );
    }, [areDefaultValuesSet]);

    const onClick = () => {
        const selectedFilters: ICreditOffersFilters = {
            price,
            period,
            contribution,
            credit_amount: price - contribution
        };
        creditCalculatorAnalytics.gtm.creditCalculatorEvent(CreditCalculatorGTMEvent.CREDIT_INSTALMENT_CALCULATOR, {
            credit_action: CreditCalculatorListingActions.FILTERS_ACCEPT,
            ...selectedFilters
        });
        setCreditFiltersStorage(selectedFilters);
        onFiltersSet(selectedFilters);
    };

    return (
        <div>
            <div css={headerWrapper}>
                <Image src={calculatorSvg} alt="Kalkulator" width="130" height="110" />
                <div>
                    <Text
                        variant="headline_1"
                        align={isMobile ? "center" : "start"}
                        css={[onDesktop(ml(3))]}
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.TITLE}
                    >
                        Kalkulator kredytu hipotecznego: <Highlight>sprawdź najlepsze oferty</Highlight>
                    </Text>
                    <Text
                        variant="body_copy_1"
                        align={isMobile ? "center" : "start"}
                        css={[mt(1), onDesktop(ml(3))]}
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.SUBTITLE}
                    >
                        Kalkulator kredytu hipotecznego pomoże Ci nie tylko znaleźć najlepsze oferty banków, ale również oszacować miesięczną ratę oraz
                        zaplanować Twój budżet domowy. Już teraz sprawdź, jakie możliwości daje kalkulator kredytowy w Twoim przypadku!
                    </Text>
                </div>
            </div>

            <div css={filtersWrapper}>
                {CreditOffersFiltersBaseData.map((inputData) => (
                    <div key={inputData.title} css={inputWrapper} id={CREDIT_PAGES_IDS.COMMON.FORM_CONTAINER}>
                        <Text variant="body_copy_2" css={labelStyle}>
                            {inputData.title}
                        </Text>

                        <CreditOfferFilterInputs
                            {...inputData}
                            price={price}
                            period={period}
                            contribution={contribution}
                            updateValue={updateValue}
                            dataTestId={inputData.name}
                        />
                    </div>
                ))}
                <div css={inputWrapper}>
                    <Text variant="body_copy_2" css={labelStyle}>
                        Kwota kredytu
                    </Text>
                    <Input
                        value={formatBigNumbers(price - contribution)}
                        rightElement={
                            <Text variant="body_copy_2" color={theme.colors.gray[700]}>
                                zł
                            </Text>
                        }
                        inputtextalign="right"
                        disabled
                        dataTestId={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.CREDIT_AMOUNT}
                    />
                </div>
                <Button variant="filled_primary" size="small" onClick={onClick} css={btnStyle}>
                    Zastosuj
                </Button>
            </div>
        </div>
    );
};

const headerWrapper = css`
    ${flex("center", "start")};
    ${flexDirection("column")};
    ${mb(2)};

    ${onDesktop(flexDirection("row"))};

    & > div {
        ${flexDirection("column")}
    }
`;

const filtersWrapper = (theme: Theme) => css`
    ${backgroundColor(theme.colors.background[200])};
    ${elevation(4)};
    ${mb(5)};
    ${p(2)};
    margin-left: -${calculateRemSize(1.5)};
    margin-right: -${calculateRemSize(1.5)};

    ${onDesktop(css`
        ${flex("end", "start")};
        ${borderRadius(2)};
        ${mh(0)};
    `)};
`;

const labelStyle = css`
    ${mb(0.5)};
`;

const inputWrapper = css`
    ${mb(2)};

    ${onDesktop(css`
        ${pr(2)};
        ${mb(0)};
        width: 20%;
    `)};
`;

const btnStyle = css`
    width: 100%;

    ${onDesktop(css`
        width: 20%;
    `)};
`;
